export const ID_FIELD = 'id'
export const USERNAME_FIELD = 'username'
export const EMAIL_FIELD = 'email'
export const PASSWORD_FIELD = 'password'
export const PASSWORD_CONFIRM_FIELD = 'passwordConfirm'
export const CURRENT_PASSWORD_FIELD = 'currentPassword'
export const FIRST_NAME_FIELD = 'firstName'
export const LAST_NAME_FIELD = 'lastName'
export const TOTP_FIELD = 'totp'
